import {Typography} from '@mui/material'
import {FC} from 'react'
import {makeStyles} from 'tss-react/mui'

import hexToRgb from '../../../theme/hexToRgb'
import {ChatMessageFileAttachments} from '../../../types/graphqlSchema'
import ChatMessageFileAttachment from './ChatMessageFileAttachment'

const ChatMessageFileAttachmentList: FC<ChatMessageFileAttachmentListProps> = ({
  chatId, fileAttachments, fullWidth = false, isTranslationVisible,
}) => {
  const {classes: styles} = useStyles({
    fileAttachmentsCount: fileAttachments.length,
    fullWidth,
  })
  if (!fileAttachments.length) return null
  return (
    <div className={styles.root}>
      {fileAttachments.slice(0, 4).map((a, i) => (
        <ChatMessageFileAttachment
          chatId={chatId}
          isTranslationVisible={isTranslationVisible}
          key={a.id}
          value={a}
          shouldDisplayFileName={fileAttachments.length === 1}
          {...((i === 3) && (fileAttachments.length > 4) && {
            overlay: (
              <div className={styles.extraFileAttachmentsButton}>
                <Typography align="center" variant="h3">
                  +{fileAttachments.length - 3}
                </Typography>
              </div>
            ),
          })}
        />
      ))}
    </div>
  )
}

const useStyles = makeStyles<MakeStylesProps>()((
  theme,
  {fileAttachmentsCount, fullWidth},
) => ({
  extraFileAttachmentsButton: {
    alignItems: 'center',
    background: `rgba(${hexToRgb(theme.palette.text.primary)}, 0.75)`,
    borderRadius: '3px',
    bottom: 0,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    height: `calc(50% - ${theme.remSpacing(0.5)})`,
    justifyContent: 'center',
    position: 'absolute',
    right: 0,
    verticalAlign: 'center',
    width: `calc(50% - ${theme.remSpacing(0.5)})`,
  },
  root: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.remSpacing(1),
    justifyContent: 'space-between',
    maxWidth: fullWidth ? '100%' : theme.remSpacing(32),
    position: 'relative',
    ...(fileAttachmentsCount > 2 && {
      aspectRatio: '1/1',
    }),
    ...(fileAttachmentsCount === 3 && {
      '& > div': {
        '&:first-child': {
          height: '100%',
        },
        height: `calc(50% - ${theme.remSpacing(0.5)})`,
        width: `calc(50% - ${theme.remSpacing(0.5)})`,
      },
      flexWrap: 'wrap',
    }),
    ...(fileAttachmentsCount >= 4 && {
      '& > div': {
        height: `calc(50% - ${theme.remSpacing(0.5)})`,
        width: `calc(50% - ${theme.remSpacing(0.5)})`,
      },

      flexDirection: 'row',
      flexWrap: 'wrap',
    }),
  },
}))

interface MakeStylesProps {
  fileAttachmentsCount: number
  fullWidth?: boolean
}
interface ChatMessageFileAttachmentListProps {
  chatId: string
  fileAttachments: ChatMessageFileAttachments[]
  fullWidth?: boolean
  isTranslationVisible?: boolean
}

export default ChatMessageFileAttachmentList
